import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import './App.css';

import Navigation from './components/Navigation';
import BackToTop from './components/BackToTop';
import SmoothScroll from './components/SmoothScroll';
import AnimatedRoutes from './components/AnimatedRoutes';
import ScrollProgress from './components/ScrollProgress';

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <Router>
        <div className="App">
          <SmoothScroll />
          <ScrollProgress />
          <Navigation />
          <AnimatedRoutes />
          <BackToTop />
        </div>
      </Router>
    </MotionConfig>
  );
}

export default App;
